import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MediaInfoComponent from './info';
import MediaUploaderComponent from './uploader';
import LzCrudListingClass from '../../../../commons/crud/listing.class';
import { lzBytesToSize, lzHideMediaBrowser } from '../../../../../services/LzUtils';
import { crudConfig } from './crud-config';
import MediaModel from '../../../../../models/media';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TuneIcon from '@material-ui/icons/Tune';
import CheckIcon from '@material-ui/icons/Check';
import Chip from '@material-ui/core/Chip';
import Pagination from '@material-ui/lab/Pagination';
import LzToolbar from '../../../../commons/toolbar';
import LzFiltersDialog from '../../../../commons/filters-dialog';
import LzFormFieldInput from '../../../../commons/forms/fields/input';
import LzFormFieldSelect from '../../../../commons/forms/fields/select';

class MediaBrowserComponent extends LzCrudListingClass {

    constructor(props) {
        super(props, crudConfig, MediaModel);
        this.state.perPage = 12;
        this.state.showFilters = false;
        this.state.selectedTab = 'browse';
        this.state.selectedMedia = null;
    }

    loadRecords() {
        // Call the load records and then reset the selected media (make null if it no longer exists or update if its updated)
        super.loadRecords(() => {
            const { selectedMedia, records } = this.state;

            if (selectedMedia) {
                let newSelMedia = null;
                for (const media of records) {
                    if (media.id === selectedMedia.id) {
                        newSelMedia = new MediaModel(media);
                        continue;
                    }
                }
                this.setState({ selectedMedia: newSelMedia });
            }
        });
    }

    getInitFilters(props) {
        return {
            name: '',
            file_type: props?.params?.file_type || '',
            category: props?.params?.category || '',
            is_private: props?.params?.is_private ? 1 : 0,
        };
    }

    onCheckAllClick(checked) {
        if (checked) {
            this.setState({ checkedIds: this.state.records.map(r => r.id) });
        } else {
            this.setState({ checkedIds: [] });
        }
    }

    onCheckClick(checked, id) {
        const updatedCheckedIds = this.state.checkedIds.slice();

        if (checked) {
            updatedCheckedIds.push(id);
        } else {
            updatedCheckedIds.splice(updatedCheckedIds.indexOf(id), 1);
        }

        this.setState({ checkedIds: updatedCheckedIds });
    }

    onPageChange(pageNo) {
        this.setState({ curPage: pageNo }, () => this.loadRecords());
    }

    onUploadingSuccess(medias, filesErrors) {
        if (!filesErrors || 0 === filesErrors.length) {
            this.setState({ selectedTab: 'browse' }, () => this.loadRecords());
        }
    }

    onSelectMedia(media) {
        const { selectedMedia } = this.state;

        if (selectedMedia?.id === media.id) {
            this.setState({ selectedMedia: null });
        } else {
            this.setState({ selectedMedia: media });
        }
    }

    handleActionIconClick(key, rec) {
        if ('select' === key) {
            this.props.onSelect(rec);
            lzHideMediaBrowser();
        } else {
            super.handleActionIconClick(key, rec);
        }
    }

    getToolbarItems() {
        const { forSelection } = this.props;
        const { checkedIds, showFilters, showDeleted } = this.state;
        const out = [];
        const totalChecked = checkedIds.length;

        if (!forSelection) {
            if (totalChecked > 0) {
                out.push({ label: 'Activate Selected', icon: <CheckIcon />, color: 'success', variant: 'contained', onClick: () => this.handleGroupActionIconClick('status_active', 'Are you sure you want to activate all selected records?') });
                out.push({ label: 'De-Activate Selected', icon: <CloseIcon />, color: 'warning', variant: 'contained', onClick: () => this.handleGroupActionIconClick('status_inactive', 'Are you sure you want to de-activate all selected records?') });
                out.push({ label: 'Delete Selected', icon: <DeleteIcon />, color: 'danger', variant: 'contained', onClick: () => this.handleGroupActionIconClick('delete', 'Are you sure you want to delete all selected records?') });
            } else {
                out.push({ label: 'Refresh', icon: <RefreshIcon />, color: 'success', variant: 'contained', onClick: () => this.loadRecords() });
                out.push({ label: 'Show/Hide Filters', icon: <TuneIcon />, color: 'warning', variant: 'contained', onClick: () => this.setState({ showFilters: !showFilters }) });
                if (showDeleted) {
                    out.push({ label: 'Hide Deleted Records', icon: <DeleteForeverIcon />, color: 'warning', variant: 'contained', onClick: () => this.handleShowDeletedChange(false) });
                } else {
                    out.push({ label: 'Show Deleted Records', icon: <DeleteIcon />, color: 'warning', variant: 'contained', onClick: () => this.handleShowDeletedChange(true) });
                }
            }
        }

        return out;
    }

    getToolbarOtherStack() {
        const { forSelection } = this.props;
        const { records, checkedIds } = this.state;

        if (forSelection) {
            return null;
        }

        const totalVisibleRows = records.length;
        const totalChecked = checkedIds.length;

        if (totalChecked > 0) {
            return (
                <Typography color="inherit" variant="subtitle1">
                    &nbsp; {totalChecked} selected
                    <Tooltip title="Clear Selections">
                        <IconButton onClick={() => this.setState({ checkedIds: [] })}>
                            <ClearAllIcon />
                        </IconButton>
                    </Tooltip>
                </Typography>
            );
        }

        return (
            <Typography>
                <FormControlLabel
                    control={
                        <Checkbox
                            indeterminate={totalChecked > 0 && totalChecked < totalVisibleRows}
                            checked={totalVisibleRows > 0 && totalChecked === totalVisibleRows}
                            onChange={(ev) => this.onCheckAllClick(ev.target.checked)}
                        />
                    }
                    label="Check All"
                />
            </Typography>
        );
    }

    applyFilters() {
        this.loadRecords();
        this.setState({ showFilters: false });
    }

    render() {
        const { records, checkedIds, filters, showFilters, selectedTab, selectedMedia, curPage, total, perPage } = this.state;
        const { forSelection, params } = this.props;

        const totalChecked = checkedIds.length;

        if (!records) {
            return <CircularProgress />;
        }

        return (
            <Grid container spacing={1} style={{ height: '100%' }}>
                <Grid item sm={8}>
                    <Paper className="lz-paper-box" variant="outlined">
                        <Tabs indicatorColor="primary" textColor="primary"
                            value={selectedTab} onChange={(evt, val) => this.setState({ selectedTab: val })} >
                            <Tab value="browse" label="Files Library" />
                            <Tab value="upload" label="Upload Files" />
                            <Tab value="download" label="Download from Web" disabled />
                        </Tabs>

                        {'browse' === selectedTab &&
                            <React.Fragment>

                                <LzToolbar icons
                                    highlighted={totalChecked > 0}
                                    items={this.getToolbarItems()}
                                    otherStack={this.getToolbarOtherStack()}
                                />

                                <LzFiltersDialog show={showFilters}
                                    onClose={() => this.setState({ showFilters: false })}
                                    onReset={() => this.setState({ filters: this.getInitFilters(this.props) })}
                                    onApply={() => this.applyFilters()}
                                >

                                    <LzFormFieldInput fluid label="Search image name" name="name" value={filters.name}
                                        onChange={this.handleFiltersInput} />

                                    <LzFormFieldSelect label="Select file type" firstOptionText="Any..." fluid name="file_type" value={+filters.file_type}
                                        options={MediaModel.getFileTypeOptions()} onChange={this.handleFiltersInput} />

                                    <LzFormFieldSelect label="Select file visibility" firstOptionValue={0} firstOptionText="Any..." fluid name="is_private" value={filters.is_private}
                                        options={[{ value: 1, text: 'Private' }, { value: 2, text: 'Public' }]} onChange={this.handleFiltersInput} />

                                </LzFiltersDialog>

                                <Grid container spacing={1} style={{ marginTop: 12 }}>
                                    {records.map((rec, dex) =>
                                        <Grid item key={'file-' + dex} style={{ flexGrow: 1, maxWidth: 240 }}>
                                            <Card variant="outlined"
                                                className={'lz-media-card ' + (rec.id === selectedMedia?.id ? 'selected' : '')}
                                                onClick={() => this.onSelectMedia(rec)}
                                            >
                                                <CardHeader
                                                    action={forSelection ? '' :
                                                        <Checkbox
                                                            checked={checkedIds.indexOf(rec.id) >= 0}
                                                            onChange={(ev) => this.onCheckClick(ev.target.checked, rec.id)}
                                                        />
                                                    }
                                                    title={rec.name}
                                                    subheader={lzBytesToSize(rec.file_size)}
                                                />
                                                <CardMedia
                                                    image={rec.isImage ? rec.file_preview_path : null}
                                                    children={!rec.isImage ? rec.contentTypeIcon : null}
                                                    title={rec.name}
                                                />
                                                <Chip size="small" label={rec.category} />
                                                <Chip size="small"
                                                    className={'status-chip ' + (rec.deleted_at ? 'danger' : (rec.is_active ? 'success' : 'warning'))}
                                                    label={rec.deleted_at ? 'deleted' : (rec.is_active ? 'active' : 'in-active')}
                                                />
                                            </Card>
                                        </Grid>
                                    )}
                                </Grid>

                                <Pagination showFirstButton showLastButton style={{ marginTop: 12 }}
                                    page={curPage + 1} count={Math.ceil(total / perPage)}
                                    onChange={(evt, val) => this.onPageChange(val - 1)} />

                            </React.Fragment>
                        }

                        {'upload' === selectedTab &&
                            <React.Fragment>
                                <MediaUploaderComponent
                                    isPrivate={params?.is_private}
                                    callUpload={params?.direct_upload}
                                    category={params?.category}
                                    accept={MediaModel.getContentTypeFromParams(params?.content_type, params?.file_type)}
                                    onUploaded={(medias, filesErrors) => this.onUploadingSuccess(medias, filesErrors)}
                                />
                            </React.Fragment>
                        }

                        {'download' === selectedTab &&
                            <React.Fragment>
                                <p>this is download...</p>
                            </React.Fragment>
                        }

                    </Paper>
                </Grid>
                <Grid item sm={4}>
                    <MediaInfoComponent
                        forSelection={forSelection}
                        record={selectedMedia}
                        onActionIconClick={(key, rec) => this.handleActionIconClick(key, rec)}
                    />
                </Grid>
            </Grid>
        );
    }

}

export default MediaBrowserComponent;
